import { render, staticRenderFns } from "./Employee_list_logs.vue?vue&type=template&id=97ada982&scoped=true"
import script from "./Employee_list_logs.vue?vue&type=script&lang=js"
export * from "./Employee_list_logs.vue?vue&type=script&lang=js"
import style0 from "./Employee_list_logs.vue?vue&type=style&index=0&id=97ada982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ada982",
  null
  
)

export default component.exports